import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import * as Yup from 'yup';

import useRequest from '@common/react/hooks/useRequest';
import { phoneRegexp } from '@common/react/utils/validationHelpers';

import FormikField from '@app/components/UI/Forms/CustomFormikField/CustomFormikField';
import { CustomPhoneControl } from '@app/components/UI/Forms/CustomPhoneControl/CustomPhoneControl';
import { TypeRecover } from '@app/components/UI/Login/RecoverForm/RecoverForm';
import RecoverFormLayout from '@app/components/UI/Login/RecoverFormLayout/RecoverFormLayout';
import phoneIcon from '@app/images/icons/phone.svg';
import styles from '@app/components/UI/Login/PhoneRecoverForm/PhoneRecoverForm.module.scss';

interface Props {
	onChangeTypeRecover: (val: TypeRecover | null) => void;
	onChangePhoneNumber: (val: string) => void;
}

const PhoneRecoverForm: React.FC<Props> = ({ onChangeTypeRecover, onChangePhoneNumber }) => {
	const request = useRequest();

	return (
		<RecoverFormLayout
			title="Send Code by Text"
			description="Enter the mobile number associated with your account. If we find a match we'll text a code."
			initialValues={{
				phoneNumber: '',
				captcha: '',
			}}
			validationSchema={Yup.object({
				phoneNumber: Yup.string()
					.matches(phoneRegexp, 'Enter 10-digit phone number')
					.required('Phone is a required field'),
				captcha: Yup.string().required('Please check the box to submit this form'),
			})}
			onBack={() => onChangeTypeRecover(null)}
			onSubmit={(values) => (
				request('recoverByPhone', values)
					.then((val) => {
						onChangeTypeRecover(TypeRecover.verifyCode);
						onChangePhoneNumber(values?.phoneNumber || '');
					})
			)}
			successfulMessage="Message sent! Please check your messages."
			render={(formikBag) => (
				<>
					<div className={styles.fields}>
						<FormikField
							title="Phone Number*"
							fieldName="phoneNumber"
							containerClassName="custom-input"
							render={(fieldProps) => (
								<CustomPhoneControl
									withReplace={false}
									placeholder="Phone Number*"
									fieldProps={fieldProps}
									prefixIcon={phoneIcon}
								/>
							)}
						/>
						<FormikField
							containerClassName="captcha"
							fieldName="captcha"
							render={(fieldProps) => (
								<ReCAPTCHA
									sitekey="6LezTMIcAAAAACaXvLNse5bmTJpwqs0Ezm_bhTrU"
									onChange={(value) => {
										if (value) {
											formikBag.setFieldValue('captcha', value || '');
										} else {
											formikBag.setFieldValue('captcha', '');
										}
									}}
									onExpired={() => {
										formikBag.setFieldValue('captcha', 'expired');
									}}
									hl="en"
								/>
							)}
						/>
					</div>
					<p className={styles.smallDesc}>
						By clicking Continue you consent to receive text messages from the Pet Hospice Journal to the mobile number
						provided. Message & data rates may apply.
					</p>
				</>
			)}
		/>
	);
};

export default PhoneRecoverForm;
